var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._b({attrs:{"color":"black","items":_setup.industryItems,"item-value":"value","item-text":"label","outlined":"","placeholder":"Select industry"},model:{value:(_setup.value),callback:function ($$v) {_setup.value=$$v},expression:"value"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }